import { render, staticRenderFns } from "./ContactsModule.vue?vue&type=template&id=8bb5cdfc&scoped=true"
import script from "./ContactsModule.vue?vue&type=script&lang=js"
export * from "./ContactsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb5cdfc",
  null
  
)

export default component.exports